import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDebianComponent } from './simple-icons-debian.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDebianComponent ],
    exports:      [ SimpleIconsDebianComponent ],
    bootstrap:    []
})
export class SimpleIconsDebianModule {}
